import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import CorporateNumberAndLabels from "../parts/CorporateNumberAndLabels";
import CorporationNameAndKeymanName from "../parts/CorporationNameAndKeymanName";
import Position from "../parts/Position";

const styles = () => ({
  root: {
    width: "450px",
    minWidth: "450px",
    height: "100%",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
  },
});

const KeymanAttribute = ({ classes, item, disabled, hotScore }) => {
  return (
    <div className={classes.root}>
      <CorporateNumberAndLabels item={item} />
      <CorporationNameAndKeymanName item={item} disabled={disabled} hotScore={hotScore} />
      <Position item={item} disabled={disabled} />
    </div>
  );
};

KeymanAttribute.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  hotScore: PropTypes.number,
};

export default withStyles(styles)(KeymanAttribute);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/KeymanAttribute.jsx